
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter, faInfoCircle, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons'

import React, { Fragment as F,
  useContext, useEffect, useLayoutEffect, useState,
} from 'react'
import {
  Link,
  useParams,
} from "react-router-dom"
import Select from 'react-select'

import {
  useApiRouter,
  appRouter,
  C,
  logg,
} from '$shared'
import {
  AppCtx,
} from '$src/App'
import {
  CloseBtn,
} from '$src/components'
import {
  DocShow,
  SchedulesCtx,
  ScheduleShow,
  SchedulesList,
} from '$src/components/schedules'

import {
  BankTabs,
  BanksCtx,
  ContactsList,
} from './'

library.add( faFilter, faInfoCircle, faSearch, faTimes )




/**
 * BankSchedules
**/
const BankSchedules = (props) => {
  logg(props, 'BankSchedules')

  const apiRouter = useApiRouter()

  const _params = useParams()
  // logg(params, 'params in BankSchedules')

  const {
    actionName, setActionName,
    params, setParams,
  } = useContext(AppCtx)
  // logg(useContext(AppCtx), 'AppCtx in BankSchedules')

  const {
    activeBankTab, setActiveBankTab,
    bank, setBank,
    results,
  } = useContext(BanksCtx)

  const {
    oneResultTitle, setOneResultTitle, defaultOneResultTitle,
    schedulesOpen, setSchedulesOpen,
    schedulesList,
  } = useContext(SchedulesCtx)

  useEffect(() => {
    if (props.action) { // specifically for docs#show, /banks/results, banks#contacts
      setActionName(props.action)
    }
  }, [ props.action ])

  /*
   * setActiveBankTab, setBank
  **/
  useEffect(() => {
    if (!actionName) { return }

    switch (actionName) {
    case 'banks#contacts':
      setActiveBankTab(C.bankTabs.contacts)
      break;

    case C.actions['banks#schedule']:
      setActiveBankTab(C.bankTabs.schedules)
      break;

    case 'docs#show':
      // nothing?!
      break

    case appRouter.banksResultsRoute: // '/banks/results'
      // nothing?!
      break

    default:
      // nothing
    }

  }, [actionName])

  useEffect(() => {
    if (_params.rssd) {
      fetch(apiRouter.bankPath({ rssd: _params.rssd, })).then(r => r.json()).then(bank => {
        setBank(bank)
      })
    }
  }, [ _params.rssd ])

  useEffect(() => {
    if (_params.schedule_id) {
      setParams({ schedule_id: _params.schedule_id })
    }
  }, [ _params.schedule_id ])


  useEffect(() => {
    // logg(bank, 'usingEffect in BankSchedules')
    if (bank.name) {
      setOneResultTitle(<F>
        {`${bank.name} [Cert: ${bank.cert}] ${bank.city}, ${bank.state}`} &nbsp;
        <Link to='/' >
          <CloseBtn onClick={() => results.length ? setOneResultTitle(null) : setOneResultTitle(defaultOneResultTitle) } />
        </Link>
      </F>)
    }
  }, [ bank ])

  return <F>
    <BankTabs />
    <div className={`BankSchedulesW ${ 'docs#show' === actionName ? 'docs-show' : '' }`} >
      <div className='content'>
        { [ 'docs#show', C.actions['banks#schedule'] ].indexOf(actionName) != -1 && <div className={`SchedulesListW ${schedulesOpen}`} >
          <SchedulesList />
        </div> }
        { 'docs#show' === actionName && <DocShow /> }
        { C.actions['banks#schedule'] === actionName && <ScheduleShow /> }
        { 'banks#contacts' === actionName && <ContactsList /> }
      </div>
      &nbsp;
    </div>
  </F>
}
export default BankSchedules
